module.exports = __webpack_public_path__ + "img/greenland.4e893be2.png";